export const MTOOLS_ADMIN = "MTOOLS_ADMIN"

export const MTOOLS_ADMIN_LOGIN = "MTOOLS_ADMIN_LOGIN"